import React from "react";
import { connect } from "react-redux";
import { bindActionCreators } from "redux";

import PropTypes from "prop-types";

// material ui core
import Grid from "@material-ui/core/Grid";
import Paper from "@material-ui/core/Paper";
import TextField from "@material-ui/core/TextField";
import Typography from "@material-ui/core/Typography";
import { CardActions, Collapse } from "@material-ui/core";

// Style
import { withStyles } from "@material-ui/core/styles";
import subscriptionCommon from "../Subscription/common";

class CreditCardForm extends React.Component {
  CreditCardFormRender = () => {
    const { classes, orderState, handleChange, toggleConnectors } = this.props;
    return (
      <React.Fragment>
        <Paper className={classes.row} elevation={0}>
          <CardActions className={classes.listHeader} onClick={toggleConnectors("CreditCard")}>
            {/* <IconButton aria-expanded={true} aria-label="Show more">
                            {!orderState.collapsed["Billing"] ? <Remove /> : <Add />}
                        </IconButton> */}
            <Typography variant="h5" gutterBottom>
              Credit Card Information
            </Typography>
          </CardActions>
          <Collapse in={!orderState.collapsed["CreditCard"]} timeout="auto" unmountOnExit>
            <Grid container spacing={3}>
              <Grid item xs={12} md={6}>
                <TextField
                  required
                  id="cardFirstName"
                  label="Cardholder's First Name"
                  fullWidth
                  variant="outlined"
                  onChange={handleChange}
                  value={orderState.cardFirstName}
                  error={
                    !orderState.enableValidators ||
                    (orderState.cardFirstName && orderState.cardFirstName.trim().length !== 0)
                      ? false
                      : true
                  }
                  inputProps={{ maxLength: 50 }}
                />
              </Grid>
              <Grid item xs={12} md={6}>
                <TextField
                  required
                  id="cardLastName"
                  label="Cardholder's Last Name"
                  fullWidth
                  variant="outlined"
                  onChange={handleChange}
                  value={orderState.cardLastName}
                  error={
                    !orderState.enableValidators ||
                    (orderState.cardLastName && orderState.cardLastName.trim().length !== 0)
                      ? false
                      : true
                  }
                  inputProps={{ maxLength: 50 }}
                />
              </Grid>
              <Grid item xs={12} md={12}>
                <TextField
                  required
                  id="cardNumber"
                  label="Credit Card Number"
                  fullWidth
                  variant="outlined"
                  onChange={handleChange}
                  value={orderState.cardNumber.trim()}
                  error={
                    !orderState.enableValidators || (orderState.cardNumber && orderState.cardNumber.trim().length !== 0)
                      ? false
                      : true
                  }
                  inputProps={{ maxLength: 25 }}
                />
              </Grid>
              <Grid item xs={6} md={3}>
                <TextField
                  required
                  id="cardExpMonth"
                  label="Exp. month"
                  helperText="format: MM"
                  variant="outlined"
                  onChange={handleChange}
                  value={orderState.cardExpMonth.trim()}
                  inputProps={{
                    min: 1,
                    max: 12,
                    maxLength: 2,
                    inputMode: "numeric",
                    size: 4,
                    style: { textAlign: "center" }
                  }}
                  error={
                    !orderState.enableValidators ||
                    (orderState.cardExpMonth && orderState.cardExpMonth.trim().length !== 0)
                      ? false
                      : true
                  }
                />
              </Grid>
              <Grid item xs={6} md={3}>
                <TextField
                  required
                  id="cardExpYear"
                  label="Exp. year"
                  helperText="format: YYYY"
                  variant="outlined"
                  onChange={handleChange}
                  value={orderState.cardExpYear.trim()}
                  inputProps={{
                    min: 2000,
                    maxLength: 4,
                    inputMode: "numeric",
                    size: 4,
                    style: { textAlign: "center" }
                  }}
                  error={
                    !orderState.enableValidators ||
                    (orderState.cardExpYear && orderState.cardExpYear.trim().length !== 0)
                      ? false
                      : true
                  }
                />
              </Grid>
              <Grid item xs={12} md={6}>
                <TextField
                  required
                  id="cardCVV"
                  label="CVV"
                  type="password"
                  helperText="Last three or four digits on signature strip"
                  variant="outlined"
                  error={
                    !orderState.enableValidators || (orderState.cardCVV && orderState.cardCVV.trim().length !== 0)
                      ? false
                      : true
                  }
                  onChange={handleChange}
                  value={orderState.cardCVV.trim()}
                  inputProps={{ maxLength: 4, inputMode: "numeric", size: 4, style: { textAlign: "center" } }}
                />
              </Grid>
            </Grid>
          </Collapse>
        </Paper>
      </React.Fragment>
    );
  };

  render() {
    return this.CreditCardFormRender();
  }
}

CreditCardForm.propTypes = {};

function mapStateToProps(state) {
  return {};
}

function mapDispatchToProps(dispatch) {
  return {
    ...bindActionCreators({}, dispatch),
    dispatch
  };
}

CreditCardForm = connect(
  mapStateToProps,
  mapDispatchToProps
)(CreditCardForm);

export default withStyles(subscriptionCommon.styles)(CreditCardForm);
